import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyCode } from '@lsq-frontend/remote-services/all-java/common-mk0';

interface Money {
    cents: number;
    currencyCode: string;
}
const UNKNOWN_CURRENCY_CODE = CurrencyCode.UNKNOWN_CURRENCY_CODE;
const USD = CurrencyCode.USD;

@Pipe({
    name: 'lsqCurrency'
})
export class LsqCurrencyPipe implements PipeTransform {
    constructor(private currencyPipe: CurrencyPipe) {}

    public transform(
        field?: string | number | Money | Partial<Money>,
        currencyCodeInput?: string,
        display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
        digitsInfo?: string
    ): any {
        const fieldAsMoney = field as Money;
        const fieldAsScalar = field as number;
        let dollarsOrEquivalent: number;
        let currencyCode: string;

        if (fieldAsMoney != null && typeof fieldAsMoney === 'object') {
            dollarsOrEquivalent = +fieldAsMoney.cents / 100;
            currencyCode = fieldAsMoney.currencyCode;

            if (currencyCode === UNKNOWN_CURRENCY_CODE) {
                currencyCode = USD;
            }
        } else {
            dollarsOrEquivalent = +fieldAsScalar;
        }

        // Display as $ until backend handles different currency types
        return this.currencyPipe.transform(
            dollarsOrEquivalent,
            currencyCode || currencyCodeInput || USD,
            display || 'symbol',
            digitsInfo
        );
    }
}
